"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitorSessionResponseDtoStatusEnum = void 0;
exports.instanceOfVisitorSessionResponseDto = instanceOfVisitorSessionResponseDto;
exports.VisitorSessionResponseDtoFromJSON = VisitorSessionResponseDtoFromJSON;
exports.VisitorSessionResponseDtoFromJSONTyped = VisitorSessionResponseDtoFromJSONTyped;
exports.VisitorSessionResponseDtoToJSON = VisitorSessionResponseDtoToJSON;
exports.VisitorSessionResponseDtoToJSONTyped = VisitorSessionResponseDtoToJSONTyped;
/**
 * @export
 */
exports.VisitorSessionResponseDtoStatusEnum = {
    Active: 'active',
    Linked: 'linked',
    Expired: 'expired'
};
/**
 * Check if a given object implements the VisitorSessionResponseDto interface.
 */
function instanceOfVisitorSessionResponseDto(value) {
    if (!('visitorId' in value) || value['visitorId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined)
        return false;
    return true;
}
function VisitorSessionResponseDtoFromJSON(json) {
    return VisitorSessionResponseDtoFromJSONTyped(json, false);
}
function VisitorSessionResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'visitorId': json['visitorId'],
        'status': json['status'],
        'expiresAt': json['expiresAt'],
    };
}
function VisitorSessionResponseDtoToJSON(json) {
    return VisitorSessionResponseDtoToJSONTyped(json, false);
}
function VisitorSessionResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'visitorId': value['visitorId'],
        'status': value['status'],
        'expiresAt': value['expiresAt'],
    };
}
